import React from 'react';
import { Box, Card, CardContent, Grid, Typography } from '@mui/material';
import { TotalCustomer, TotalOrders, TotalProducts, TotalRevenue } from '../../Svg';



const DashCards = ({data}) => {
    const statuses = [
        {
            title: 'Total Products',
            count: data?.totalProducts || 0,
            today: 'Total Products',
            icon: <TotalProducts />,
        },
        {
            title: 'Total Revenue',
            count: data?.totalRevenue?.toFixed(2) || 0,
            today: '+14 today',
            icon: <TotalRevenue />,
        },
        {
            title: 'Total Customer',
            count:  data?.totalCustomers || 0,
            today: '+120 today',
            icon: <TotalCustomer />,
        },
        {
            title: 'Total Vendors',
            count:  data?.totalVendors || 0,
            today: '+180 today',
            icon: <TotalCustomer />,
        },
        {
            title: 'Total Orders',
            count: data?.totalOrderCount || 0,
            today: '+912 today',
            icon: <TotalOrders />,
        },
    ];
    return (

        <>
            <Box sx={{ paddingBottom: '16px', margin: '-25px -24px' }}>
                <img src='/assets/dashbg.png' width='100%' height='140px' />
                <Grid container spacing={2} sx={{
                    '&.MuiGrid-root': {
                        marginTop: '-120px',
                       paddingLeft: '26px',
                        gap: '10px',
                    }
                }}>
                    {statuses.map((status, index) => (
                        <Grid item xs={2.2} key={index}>
                            <Card sx={{
                                display: 'flex', alignItems: 'flex-start',
                                justifyContent: 'space-between', border: '1px solid #E0E2E7',
                                backdropFilter: 'blur(27.200000762939453px)',
                                border: '1px solid #FFFFFF',
                                boxShadow: '0px 12px 16px -4px #0C1A240A',
                                '&.MuiCard-root': {
                                    backgroundColor: '#ffffffba !important',
                                    padding: '8px 0px 0px 8px !important'
                                }

                            }}>
                                <CardContent sx={{
                                    '&.MuiCardContent-root': {
                                        padding: "10px 0px 10px 10px !important",
                                    }
                                }}>
                                    <Box>{status.icon}</Box>
                                    <Typography variant="body2" color="#64748B" fontSize="12px" sx={{ marginTop: "10px" }}>
                                        {status.title}
                                    </Typography>
                                    <Typography variant="h5" color="#1E293B" sx={{ p: '6px 0 0px 0' }} fontSize="30px" fontWeight='600px'>
                                        {status.count}
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Grid>
                    ))}
                </Grid>
            </Box >
        </>
    );
};

export default DashCards;
